// Call only after an explicit save has been accepted by the server.
export const SAVE_SUCCESS_EVENT = 'admin:save-success';
export function notifySaveSuccess(message = 'Changes saved') {
  window.dispatchEvent(new CustomEvent(SAVE_SUCCESS_EVENT, { detail: message }));
}
